import { isLocalStoragePersistenceDisabled } from "./storageMode";

const PREFIX = "ux-ai-storage-preference:";

export function getStoragePreference(userId) {
  if (!userId) return null;
  if (isLocalStoragePersistenceDisabled()) return null;
  try {
    const raw = localStorage.getItem(`${PREFIX}${userId}`);
    if (raw === "local" || raw === "cloud") return raw;
    return null;
  } catch (e) {
    return null;
  }
}

export function setStoragePreference(userId, mode) {
  if (!userId) return;
  if (mode !== "local" && mode !== "cloud") return;
  if (isLocalStoragePersistenceDisabled()) return;
  try {
    localStorage.setItem(`${PREFIX}${userId}`, mode);
  } catch (e) {
    // ignore
  }
}
